/**
 * Stable CSS class names for E2E — SmsTemplate page and its drawers.
 * Containers use `sms-template__<element>`; inputs and user-interactable
 * controls use `sms-template-input--<name>`.
 */
export const SMS = {
    page: 'sms-template-page',
    root: 'sms-template',

    /* --- Page header / actions ----------------------------------------- */
    header: 'sms-template__header',
    title: 'sms-template__title',
    headerActions: 'sms-template__header-actions',
    btnAdd: 'sms-template-input--button-add',

    searchBox: 'sms-template__search-box',
    inputSearch: 'sms-template-input--search',

    /* --- Drawer wrapper ------------------------------------------------- */
    drawer: 'sms-template__drawer',

    /* --- Grid + cells --------------------------------------------------- */
    grid: 'sms-template__grid',
    cellKeyword: 'sms-template__cell-keyword',
    cellKeywordText: 'sms-template__cell-keyword-text',
    cellCultureCode: 'sms-template__cell-culture-code',
    cellSubject: 'sms-template__cell-subject',
    cellBody: 'sms-template__cell-body',
    cellBodyText: 'sms-template__cell-body-text',
    cellIsActive: 'sms-template__cell-is-active',
    statusChip: 'sms-template__status-chip',
    statusChipActive: 'sms-template__status-chip--active',
    statusChipPassive: 'sms-template__status-chip--passive',
    cellEdit: 'sms-template__cell-edit',
    btnEdit: 'sms-template-input--button-edit',

    /* --- Template drawer ----------------------------------------------- */
    templateDrawer: 'sms-template__template-drawer',
    templateDrawerInner: 'sms-template__template-drawer-inner',
    templateDrawerHeader: 'sms-template__template-drawer-header',
    templateDrawerTitleBox: 'sms-template__template-drawer-title-box',
    templateDrawerTitle: 'sms-template__template-drawer-title',
    templateDrawerCloseBox: 'sms-template__template-drawer-close-box',
    btnTemplateClose: 'sms-template-input--button-template-close',

    templateForm: 'sms-template__template-form',
    templateFieldKeyword: 'sms-template__template-field-keyword',
    inputKeyword: 'sms-template-input--keyword',
    templateFieldBody: 'sms-template__template-field-body',
    inputBody: 'sms-template-input--body',
    templateFieldSubject: 'sms-template__template-field-subject',
    inputSubject: 'sms-template-input--subject',
    templateFieldCultureCode: 'sms-template__template-field-culture-code',
    inputCultureCode: 'sms-template-input--culture-code',

    templateFieldIsActive: 'sms-template__template-field-is-active',
    inputIsActiveLabel: 'sms-template__template-field-is-active-label',
    inputIsActive: 'sms-template-input--is-active',

    templateActions: 'sms-template__template-actions',
    templateActionsLeft: 'sms-template__template-actions-left',
    btnSendSms: 'sms-template-input--button-send-sms',
    templateActionsRight: 'sms-template__template-actions-right',
    btnTemplateUpdate: 'sms-template-input--button-template-update',
    btnTemplateSave: 'sms-template-input--button-template-save',

    /* --- Trigger (send-sms) dialog ------------------------------------ */
    triggerDialog: 'sms-template__trigger-dialog',
    triggerDialogContent: 'sms-template__trigger-dialog-content',
    triggerDialogInner: 'sms-template__trigger-dialog-inner',
    triggerHeader: 'sms-template__trigger-header',
    triggerTitleBox: 'sms-template__trigger-title-box',
    triggerTitle: 'sms-template__trigger-title',
    triggerCloseBox: 'sms-template__trigger-close-box',
    btnTriggerClose: 'sms-template-input--button-trigger-close',

    triggerForm: 'sms-template__trigger-form',
    triggerFieldPhone: 'sms-template__trigger-field-phone',
    inputTriggerPhone: 'sms-template-input--trigger-phone',
    triggerFieldCustomerId: 'sms-template__trigger-field-customer-id',
    inputTriggerCustomerId: 'sms-template-input--trigger-customer-id',
    triggerKeywordList: 'sms-template__trigger-keyword-list',
    triggerKeywordField: 'sms-template__trigger-keyword-field',
    inputTriggerKeyword: 'sms-template-input--trigger-keyword',

    triggerActions: 'sms-template__trigger-actions',
    triggerActionsRow: 'sms-template__trigger-actions-row',
    btnTriggerSend: 'sms-template-input--button-trigger-send',
} as const;

export const smsCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
